<template>
  <li class="coin-list" @click="showCoinList">
    <div class="rect">
      <a class="label">{{ $t('tokens.listToken') }}</a>
    </div>
    <div class="tip"></div>
    <img class="list-coin__icon" src="@/assets/coin-list.png" />
  </li>
</template>
<script setup lang="ts">
import { CoinListDialog } from '@/components/Dialogs/CoinListDialog';
import { useDialogStore } from '@/store';
import { useDialog } from 'primevue/usedialog';
import { DialogHeader } from '../DialogHeader';
import { h } from 'vue';

const dialogStore = useDialogStore();
const dialog = useDialog();

function showCoinList() {
  dialogStore.setDialogTitle('');
  dialogStore.setHasBack(false);
  dialog.open(CoinListDialog, {
    props: {
      modal: true,
      contentStyle: { maxWidth: '483px' },
      draggable: false,
      closable: true,
      dismissableMask: true,
      showHeader: dialogStore.showHeader,
      contentClass: 'coin-list-dialog',
    },
    templates: {
      header: () =>
        h(DialogHeader, {
          title: dialogStore.dialogTitle,
          hasBack: dialogStore.hasBack,
        }),
    },
    onClose() {
      dialogStore.resetDialogState();
    },
  });
}
</script>
<style lang="scss">
$transitionTime: 0.25s;

.coin-list {
  position: fixed;
  display: flex;
  flex-direction: row;
  bottom: 20px;
  right: 84px; // 104px
  align-items: center;
  cursor: pointer;
  z-index: 97;

  .label {
    color: rgba(#fbfaff, 0.6);
    transition: $transitionTime;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;

    @media (min-width: 1024px) {
      font-size: 13px;
    }
  }

  @media (max-width: 1024px) {
    position: initial;
    flex-direction: row-reverse;
  }

  .tip {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-left: 4px solid #16162d;
    border-bottom: 5px solid transparent;
    margin-right: 13px;
    transition: $transitionTime;

    @media (max-width: 1024px) {
      display: none;
    }
  }

  .rect {
    background-color: #16162d;
    border-radius: 4px;
    padding: 2px 8px;
    transition: $transitionTime;

    @media (max-width: 1024px) {
      background: none;
      padding: 2px 12px;
    }
  }

  .list-coin__icon {
    height: 48px;
    width: 48px;
    animation: none;
    transform: translateY(0);

    @media (max-width: 1024px) {
      width: 24px;
      height: 24px;
    }
  }

  @media (min-width: 1024px) {
    &:hover {
      .label {
        opacity: 1;
      }

      .rect {
        background-color: #6e42ca;
      }

      .tip {
        border-left-color: #6e42ca;
      }

      .list-coin__icon {
        animation: flow-animation 2s infinite;
      }
    }
  }
}

$amplitude: 4px;
@keyframes flow-animation {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-$amplitude);
  }
  75% {
    transform: translateY($amplitude);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
